import { TestimonialSlider, Track } from './TestimonialSlider';
import Navigation from './Navigation';
import NavigationItem from './NavigationItem';
TestimonialSlider.displayName = "TestimonialSliderBase";
Track.displayName = "TestimonialSlider.Track";
Navigation.displayName = "TestimonialSlider.Navigation";
export { TestimonialSlider as default, Track };
export { Navigation, NavigationItem };